<!-- ═══════════════════════════════════════════════════════════
     NEW — compact inline strip
════════════════════════════════════════════════════════════ -->
@if (!legacy) {
  <div class="rip">

    <!-- Source -->
    <div class="rip__field">
      <span class="rip__label">{{ 'reports.source' | translate }}</span>
      <span class="rip__value">
        @if (reportData?.source) {
          {{ 'reports.sources.' + reportData.source | translate }}
          <span class="rip__cache">{{ metaStatusCode | reportCacheRegister }}</span>
        } @else {
          <span class="rip__value--empty">—</span>
        }
      </span>
    </div>

    <div class="rip__sep"></div>

    <!-- Report date -->
    <div class="rip__field">
      <span class="rip__label">{{ 'reports.toDate' | translate }}</span>
      <span class="rip__value rip__value--mono">
        {{ (reportTime | date) || '—' }}
      </span>
    </div>

    <div class="rip__sep"></div>

    <!-- Operator -->
    <div class="rip__field">
      <span class="rip__label">{{ 'global.operator' | translate }}</span>
      <span class="rip__value">{{ requesterName || '—' }}</span>
    </div>

    <div class="rip__sep"></div>

    <!-- ID card number -->
    <div class="rip__field">
      <span class="rip__label">{{ 'identityReports.idCardNumber' | translate }}</span>
      <span class="rip__value rip__value--mono">{{ idCardNumber || '—' }}</span>
    </div>

    <div class="rip__sep"></div>

    <!-- Report selector -->
    <div class="rip__select-wrap">
      <button class="rip__select-trigger"
              [matMenuTriggerFor]="reportMenu"
              [disabled]="!listData?.length">

        @if (reportData) {
          <span class="rip__select-label">
            <b>{{ 'reports.types.' + reportData.type?.toLowerCase() | translate }}</b>
            &nbsp;/&nbsp;
            <span class="rip__value--mono">{{ requestTime | itfgDateFormat }}</span>
          </span>
        } @else {
          <span class="rip__select-placeholder">{{ 'nssi.chooseNssiReport' | translate }}</span>
        }

        @if (isStale) {
          <mat-icon class="rip__stale-icon"
                    [matTooltip]="'credits.ccrOverTwoMonts' | translate"
                    matTooltipPosition="above">
            warning
          </mat-icon>
        }

        <mat-icon class="rip__chevron">expand_more</mat-icon>
      </button>

      <mat-menu #reportMenu="matMenu" class="rip-menu">
        @for (report of listData; track report.id) {
          <button mat-menu-item class="rip-menu__item"
                  (click)="selectReport(report)"
                  [class.rip-menu__item--active]="compareItemsById(report, reportData)">
            <span class="rip-menu__label">
              {{ 'reports.types.' + (report.type ?? reportData?.type)?.toLowerCase() | translate }}
              &nbsp;/&nbsp;
              <span class="rip__value--mono">{{ report.time | itfgDateFormat }}</span>
            </span>
            @if (report.time.getTime() + twoMontsMiliseconds < currentDate.getTime()) {
              <mat-icon class="rip-menu__warn"
                        [matTooltip]="'credits.ccrOverTwoMonts' | translate"
                        matTooltipPosition="above">
                warning
              </mat-icon>
            }
          </button>
        }
      </mat-menu>
    </div>

  </div>
}

<!-- ═══════════════════════════════════════════════════════════
     LEGACY — original mat-form-field row (legacy=true)
════════════════════════════════════════════════════════════ -->
@if (legacy) {
  <div flex layout="row" layout-wrap>

    <div flex-gt-md="20" flex-gt-sm="20" flex-gt-xs="50" flex="40"
         layout="row" layout-align="start center">
      <mat-form-field flex="100">
        <mat-label><span [translate]="'reports.source'">Choose source</span></mat-label>
        <input matInput type="text" readonly
               [value]="listData?.length > 0 && reportData?.source
                 ? ('reports.sources.' + reportData.source | translate) + (metaStatusCode | reportCacheRegister)
                 : ''" />
      </mat-form-field>
    </div>

    <div flex-gt-md="20" flex-gt-sm="20" flex-gt-xs="50" flex="60"
         layout="row" layout-align="start center">
      <mat-form-field flex="100">
        <mat-label><span [translate]="'reports.toDate'">From</span></mat-label>
        <input matInput type="text" readonly
               [value]="listData?.length > 0 && reportTime ? (reportTime | date) : null" />
      </mat-form-field>
    </div>

    <div flex-gt-md="20" flex-gt-sm="20" flex-gt-xs="50" flex="40"
         layout="row" layout-align="start center">
      <mat-form-field flex="100">
        <mat-label><span [translate]="'global.operator'">Operator</span></mat-label>
        <input matInput type="text" readonly [value]="requesterName" />
      </mat-form-field>
    </div>

    <div flex-gt-md="40" flex-gt-sm="40" flex-gt-xs="50" flex="60"
         layout="row" layout-align="start center">
      <mat-form-field flex="100" class="white-space-no-wrap">
        <mat-label><span [translate]="'reports.reportFromDate'">From</span></mat-label>
        <mat-select matInput [(value)]="reportData"
                    (selectionChange)="listDataChanged($event)"
                    placeholder="{{ 'nssi.chooseNssiReport' | translate }}"
                    disableOptionCentering="true"
                    [compareWith]="compareItemsById">
          <mat-select-trigger>
            <div flex layout="row" layout-wrap layout-align="space-between center">
              <span>
                <b>{{ (reportData?.type ? 'reports.types.' + reportData.type.toLowerCase() : '') | translate }}</b>
                / {{ requestTime | itfgDateFormat }}
              </span>
              @if (isStale) {
                <mat-icon matIconSuffix
                          [matTooltip]="'credits.ccrOverTwoMonts' | translate"
                          matTooltipPosition="above"
                          [ngStyle]="{'margin-right': '10px', color: 'red'}">
                  warning
                </mat-icon>
              }
            </div>
          </mat-select-trigger>
          @for (report of listData; track report) {
            <mat-option [value]="report">
              <span flex layout="row" layout-align="space-between center">
                <span [ngStyle]="{'width': '250px'}">
                  {{ 'reports.types.' + (report.type ?? reportData?.type?.toLowerCase()) | translate }}
                  / {{ report.time | itfgDateFormat }}
                </span>
                @if (report.time.getTime() + twoMontsMiliseconds < currentDate.getTime()) {
                  <mat-icon matIconSuffix
                            [matTooltip]="'credits.ccrOverTwoMonts' | translate"
                            matTooltipPosition="above">
                    warning
                  </mat-icon>
                }
              </span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

  </div>
}